const accordionTabComponet = {
    props: { 
        btnMoreTxt: "",
        btnHelpTxt: "",
        viewAccordionLimit: {
            type: Number,
            default: 5
        },        
        interactDiv: {
            type: String,
            default: ""
        },
        handler: {
            type: String,
            default: ""
        },
     },   
    template:
    `<div class="strip-conts" v-if="data.length">
        <div class="s-accordion-tabs__body">

            <div class="s-accordion-tabs__tabs" v-if="tabs.length > 1">
                <ul>
                    <li v-for="(item, index) in tabs"
                        :key="item.value">
                        <a href="javascript:void(0)"
                        :title="item.text"
                        class="btn--outline-black btn--outline-thin"
                        :class="[ selectedTab === item.value ? 'is-active' : '' ]"
                        @click="onClickTab(item.value)">
                            {{item.text}}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="s-accordion-tabs__main">
                <div class="s-accordion-tabs__aside">
                    <ul class="d-none d-lg-block">
                        <li v-for="(item, index) in groups"
                            :key="item.value">
                            <a href="javascript:void(0)"
                            :title="item.title"
                            :class="[ selectedGroup === item.value ? 'is-active' : '' ]"
                            @click="onClickGroup(item.value)">
                                <span class="title">
                                    {{item.title}}
                                </span>
                                <span class="sub-title">
                                    {{item.subTitle}}
                                </span>
                            </a>
                        </li>
                    </ul>
                    <div class="d-lg-none">
                        <select class="form-select"
                                name="subject"
                                v-model="selectedGroup">
                            <option v-for="(item, index) in groups"
                                    :value="item.value"
                                    :key="item.value">
                                {{item.title}}
                            </option>
                        </select>
                    </div>                    
                </div>
                <div class="s-accordion-tabs__faqs">
                    <!--b-accordion-->
                    <div class="b-accordion">
                        <template v-for="(item, index) in faqs" :key="item.id">
                            <template v-if="isExpaned(item.id)===false && index < viewAccordionLimit">
                                <h3 class="b-accordion__head">
                                    {{item.title}}
                                </h3>
                                <div class="b-accordion__conts"
                                    v-html="item.text">
                                </div>										
                            </template>
                            <template v-if="isExpaned(item.id)===true">
                                <h3 class="b-accordion__head">
                                    {{item.title}}
                                </h3>
                                <div class="b-accordion__conts"
                                    v-html="item.text">
                                </div>
                            </template>                            
                        </template>
                    </div>
                    <div class="s-accordion-tabs__faqs__cta">
                        <template v-for="(item, index) in faqs">
                            <button v-if="isExpaned(item.id)===false && (faqs.length > viewAccordionLimit) && index === 0 " 
                                @click="expandSelected(item.id)" 
                                type="button" 
                                class="btn--outline-blue btn--block">{{btnMoreTxt}}</button>
                        </template>

                        <button v-if="interactDiv!==''" type="button" @click="doInteract" class="btn--black btn--block">{{btnHelpTxt}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    mixins: [mixins],
	data: function () {
		return {
			$this: [],
			data: [],
			selectedTab: null,
			selectedGroup: null
		};
	},

	mounted () {		
		this.loadData()			

	},
	methods: {

		loadData(){
            this.loading = true;

            this.ajax(this.handler, { page: this.page, sort: this.sort })

        },

		handleError(errorMessages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },

        handleAjaxSuccess(data) {           
            this.data.push(...data);
            
			this.selectedTab = this.tabs[0].value
			this.selectedGroup = this.groups[0].value

			this.$nextTick(function () {	
				
				this.refreshAccordion()
			})
        },
		

		onClickTab: function (value) {
			this.selectedTab = value
			this.selectedGroup = this.groups[0].value
			this.refreshAccordion()
		},

		onClickGroup: function (value) {
			this.selectedGroup = value

		},

		refreshAccordion: function () {

			var elem = jQuery(".b-accordion", jQuery(this.$el))

			if (!elem.hasClass('ui-accordion')) {
				elem.accordionSection({
					header: '.b-accordion__head'
				})
				return false
			}

			this.$nextTick(function () {				
				elem.accordion("refresh")
			})
		},

		isExpaned(id){

			var isExpanded = null
			
			this.data.forEach(function (topNode) {
				topNode.groups.forEach(function(groups){
					groups.faqs.forEach(function(faq){
						if(faq.id=== id){
							isExpanded = groups.expanded
						}
					})

				})
				
			})

			if(isExpanded!==null){
				return isExpanded
			}

			return false
		},

		expandSelected(id){

			this.data.forEach(function (item) {
				item.groups.forEach(function (groups) {
					groups.faqs.forEach(function(faq){
						if(faq.id=== id){
							groups.expanded = true
						}
					})
				})
			})

			this.refreshAccordion()
		},
		doInteract(){
			if(this.interactDiv){
				var div = jQuery(this.interactDiv)
				if(div && div.length){
					div.slideDown()
					api.fn.moveWindowToObj(div)
				}
			}
		}
	},

	computed: {
		tabs: function () {
			return this.data.map(i => ({ value: i.id, text: i.title }))
		},

		groups: function () {

			if (!this.hasValue(this.selectedTab)) {
				return []
			}

			return this.data.find(i => i.id === this.selectedTab)
				.groups
				.map(i => ({ value: i.id, title: i.title, subTitle: i.subTitle }))
		},

		faqs: function () {

			if (!this.hasValue(this.selectedTab)) {
				return []
			}

			if (!this.hasValue(this.selectedGroup)) {
				return []
			}

			return this.data
				.find(i => i.id === this.selectedTab)
				.groups
				.find(i => i.id === this.selectedGroup)
				.faqs
				.map(i => ({ id: i.id, title: i.title, text: i.text }))
		}
	},
	watch: {
		selectedGroup: function (val) {
			this.refreshAccordion()
		}
	}
}
